/**
 * @fileoverview > handler for the "/engagement/campaigns/:app_group_id/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsAppGroupIdUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementCampaignsAppGroupIdUpdateArchivedStateProps,
  EngagementCampaignsAppGroupIdUpdateArchivedStateResult,
} from "./types";

export const postEngagementCampaignsAppGroupIdUpdateArchivedState = reactQueryMutationAdapter(
  engagementCampaignsAppGroupIdUpdateArchivedStateCacheKeys,
  (
    props: PostEngagementCampaignsAppGroupIdUpdateArchivedStateProps
  ): Promise<EngagementCampaignsAppGroupIdUpdateArchivedStateResult> => {
    const { app_group_id, ...params } = props;
    const actualParams = props.mark_as_archived
      ? params
      : {
          app_group_id: app_group_id,
          ...params,
        };
    return fetch(`/engagement/campaigns/${app_group_id}/update_archived_state`, "POST", actualParams);
  }
);
